export default __webpack_public_path__ + "static/media/Angle.e025ad7b.svg";